<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini" style="margin-left: -45px;">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="정산년월" label-width="120px">
                <el-col :span="10">
                  <el-select v-model="form.years">
                    <el-option
                        v-for="item in combos['years']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="10">
                  <el-select v-model="form.months">
                  <el-option
                      v-for="item in combos['months']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="정산여부" label-width="120px">
                <el-select v-model="form.squareYn">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['squareYn']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="처리자" label-width="120px">
                <el-select v-model="form.userId" >
                  <el-option value="" label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['agerntUser']"
                      :key="item.key"
                      :value="parseInt(item.key)"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                row-selection="single"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal_01 from "@/components/AS/History/Modal/ReceptionModal_02";
import ReceptionModal from "@/components/AS/CallDispose/Modal/ReceptionModal";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  props: {
  },
  data() {
    return {
      data: [],
      form: {
        years : this.$moment().format('YYYY'),
        months : this.$moment().format('MM'),
        squareYymm : '',
        companyId : '',
        squareYn : 'Y',              // 정산구분
        catId : '',                 // 지역/센터
        userId : '',
        sortType :  '',
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'years' : [],
        'months' : [],
        'catId' : [],
        'squareYn' : [],
        'agerntUser' : [],
      },
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 40px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:false
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    createMainColumnDefs() {
      const that = this
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'정산여부', field:'squareYn', width:110, cellStyle:{textAlign: 'center'},
          valueFormatter: (params) => {
            return that.getSquareType(`${params.value}`)
          }
        } ,
        {headerName:'처리일자', field:'procDt', width:110, cellStyle:{textAlign: 'center'},
          valueFormatter: (params) => {
            return that.getDateFormat(`${params.value}`)
          }
        },
        {headerName:'구분', field:'squareType', width:110, cellStyle:{textAlign: 'center'} },
        {headerName:'접수번호', field:'squareId', width:110, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }
        },
        {headerName:'', field:'asAgentId', width:110, hide:true },
        {headerName:'신고자', field:'custNm', width:110, cellStyle:{textAlign: 'center'} },
        {headerName:'처리자', field:'keyManNm', width:110, cellStyle:{textAlign: 'center'} },
        {
          headerName: 'A/S',
            children: [
              {
                headerName: '유상',
                children: [
                  {headerName:'자재비', field:'inAsItemUnitAmt', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.chkNumber(params, '', '');
                    }},
                  {headerName:'이관비', field:'inAsCallUnitAmt', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.chkNumber(params, '', '');
                    }},
                  {headerName:'대수', field:'inAsQty', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.chkNumber(params, '', '');
                    }},
                  {headerName:'합계', field:'inAsAmt', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.chkNumber(params, '', '');
                    }},
                ]
              },
              {
                headerName: '무상',
                children: [
                  {headerName:'기본비', field:'outAsUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.chkNumber(params, '', '');
                    }},
                  {headerName:'원거리출장비', field:'outAsEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.chkNumber(params, '', '');
                    }},
                  {headerName:'기타비용', field:'outAsEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.chkNumber(params, '', '');
                    }},
                  {headerName:'대수', field:'outAsQty', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.chkNumber(params, '', '');
                    }},
                  {headerName:'합계', field:'outAsAmt', width:120, cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                      return that.chkNumber(params, '', '');
                    }},
                ]
              }
          ],
        },
        {
          headerName: 'BS/MA',
              children: [
                {headerName:'처리비', field:'outBsmaUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
                {headerName:'원거리출장비', field:'outBsmaEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
                {headerName:'기타비용', field:'outBsmaEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
                {headerName:'대수', field:'outBsmaQty', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
                {headerName:'합계', field:'outBsmaAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
              ]
            },
            {
              headerName: '설치',
              children: [
                {headerName:'설치비1', field:'outSetupUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
                {headerName:'설치비2', field:'outSetupUnitPrice2', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
                {headerName:'원거리출장비', field:'outSetupEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
                {headerName:'기타비용', field:'outSetupEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
                {headerName:'대수', field:'outSetupQty', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
                {headerName:'합계', field:'outSetupAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return that.chkNumber(params, '', '');
                  }},
          ],
        },
        {
          headerName: '합계',
          children: [
            {headerName:'대수', field:'outSetupQty', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return that.chkNumber(params, '', '');
              }},
            {headerName:'합계', field:'outSetupAmt', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return that.chkNumber(params, '', '');
              }},
          ]
        }
      ];
    },
    onCellClicked(params) {
      const idx = params.rowIndex;
      const field = params.colDef.field;
      if(field === 'squareId') {
        this.openModel(params.data);
      }
    },
    /**
     * 접수/처리 상세 팝업 오픈
     */
    openModel(param) {
      console.log(param);
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ReceptionModal,
        parent: this,
        props: {
          data: {
            asId: param.squareId,
            custId: param.custId,
            sortType: '',
            popHeadInfo: {}, //this.custParam.popHeadInfo,
            //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
            recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
            procsDt: this.$moment(param.procDt).format('YYYY-MM-DD'),
            menuGubun : 'AgentCalculationList'
          }
        },
        events: {
          close(data) {
            console.log('close', data);
          },
        }
      });
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      let that = this
      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/aCalculation/list"), {
        companyId : this.form.companyId,
        squareYymm : this.form.years + this.form.months,
        squareYn : this.form.squareYn,          // 정산구분
        asAgentId : this.$store.state.loginInfo.asAgentId,
        userId : this.form.userId == '' ? 0 : this.form.userId,
        sortType :  '',
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 0,
        processTime : ''
      }).then(response => {
        console.log('response.data' , response.data)
        this.data = response.data
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    getSquareType(val){
      if(val){
        return val === 'Y' ? '정산' : '미정산'
      }
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/workMng/calculation/init`)
          .then(response => {
            this.combos['years'] = response.data.years;
            this.combos['months'] = response.data.months;
            this.combos['catId'] = response.data.catId;
            this.combos['squareYn'] = response.data.squareYn;
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });

      this.init2();
      this.createMainColumnDefs();
    },
    async init2() {
      this.$store.commit('loading');
      await this.$http.post('/api/scheduleMng/init')
          .then(response => {
            this.combos['agerntUser'] = response.data.agerntUser;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });
    },
    chkNumber(params, flag, excRt){
      var result = '';
      var val = params.value;
      var data = this.data;

      if(flag === 'sub'){
        data = this.subData;
      }

      if(!_.isEmpty(val) || _.isNumber(val)){
        val = val.toString();

        if (excRt === 'excRt'){
          result = this.$numeral(val).format('0,0.00');
        } else {
          result = this.$numeral(val).format('0,0');
        }

        data[params.node.id][params.column.colId] = this.$numeral(val).value();
      }

      return result
    },

  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>